// lib
import { createAction } from "@reduxjs/toolkit";

export const updateFocus = createAction("table/focus/update");
export const updateRange = createAction("table/range/update");
export const updateView = createAction("table/view/update");
